import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-line bg-white/95 shadow-sm backdrop-blur" data-id="element-241" data-mp="232nfsn0fptzi">
      <div className="bg-ink px-3 py-1.5 text-center text-[10px] font-extrabold uppercase tracking-wide text-white sm:text-xs md:text-sm" data-id="element-242" data-mp="1y30urred79g5">
        🇦🇷 EL SISTEMA COMPLETO PARA ENTRENAR EN CASA EN ARGENTINA
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-semibold text-ink/60 md:flex" data-id="element-243" data-mp="2qr6gagd8t2h1">
        <span className="flex items-center gap-1.5" data-id="element-244" data-mp="2lvhk8n0fm3ph">
          <ZapIcon className="h-3.5 w-3.5 text-primary" data-id="element-245" data-mp="2h1mvh55yyyjj" /> Acceso en 5 minutos
        </span>
        <span className="text-accent" data-id="element-246" data-mp="2c4d77subgsxa">·</span>
        <span className="flex items-center gap-1.5" data-id="element-247" data-mp="2c1h8i2ana07s">
          <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-248" data-mp="39j92064qr8y5" /> Pago seguro
        </span>
        <span className="text-accent" data-id="element-249" data-mp="34rqvz3nv2i6b">·</span>
        <span className="flex items-center gap-1.5" data-id="element-250" data-mp="34qxy6s6vr30b">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-251" data-mp="24pran8wvoxx" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}